import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-email-logs-page',
  templateUrl: './email-logs-page.component.html',
  styleUrls: ['./email-logs-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class EmailLogsPageComponent {}
